import type { UserDischargeApi } from "@/Modules/Customers/Model/Api/Discharge";
import type { UserDischarge } from "@/Modules/Customers/Model/Domain/Discharge";

import { useCustomerStore } from "@/Modules/Customers/Store";

import DischargeApiConnector from "@/Services/TherapyApi/Discharge";

import { hasValue } from "@/Utils/Objects";
import { camel } from "@/Utils/Camelize";
import { log } from "@/Utils/Debug";

async function fetchUserDischargeAH(): Promise<UserDischarge | undefined> {
  const customerStore = useCustomerStore();
  const dischargeApi = new DischargeApiConnector();

  if (!hasValue(customerStore.selected)) return undefined;

  const discharge = await dischargeApi.getUserDischarge(customerStore.selected.id).catch((e) => {
    log(e);

    return undefined;
  });

  if (!hasValue(discharge)) return undefined;

  return camel<UserDischargeApi, UserDischarge>(discharge);
}

export default fetchUserDischargeAH;
